<template>
  <div class="platformTotal">
    <NewHeader></NewHeader>
    <!-- 标题 -->
    <div class="institution-title">
      <!-- <img :src="insTitleImg" alt /> -->
      <HeadTitle></HeadTitle>
    </div>
    <div class="navigation">
      <span class="color-blue" @click="$router.push({path:'/'})">首页</span>
      <span
        class="cur-pointer color-blue"
        @click="toHengFengPage"
        v-show="isChildPage"
      >&nbsp;/&nbsp;横峰县副中心</span> &nbsp;/
      &nbsp;影像上传量
    </div>
    <div class="content">
      <!-- <div class="content-title">{{titleTxt}}医学影像平台总会诊数</div> -->
      <table>
        <tr>
          <td>上传机构</td>
          <td>上传量</td>
        </tr>
		<tr v-for="(tableData,index) in tableDatas">
		  <td @click="toHosDetail(tableData.hospital_id)">{{ tableData.hospital_name }}</td>
		  <td>{{ tableData.total }}</td>
		</tr>
		<tr>
		  <td>{{ tableTotal.totalSum }}</td>
		  <td>{{ tableTotal.upLoadSum}}</td>
		</tr>
      </table>
    </div>

    <NewFooter></NewFooter>
  </div>
</template>

<script>
import NewHeader from "../components/NewHeader.vue";
import HeadTitle from "../components/HeadTitle.vue";
import NewFooter from "../components/NewFooter.vue";
export default {
  name: "platformTotal",
  data() {
    return {
      insTitleImg: require("../assets/img/regInstitution/hengfeng_title.png"), // 标题图片
      tableDatas: [],
      tableTotal: {}, // 合计
      titleTxt: "上饶市",
      ifNull: false,
      isChildPage: false
    };
  },
  components: {
    NewHeader,
    HeadTitle,
    NewFooter
  },
  methods: {
    // 设置参数
    setParams() {
      let that = this;
      let params = new URLSearchParams();
      let province = that.$route.query.province;
      let city = that.$route.query.city;
      let area = that.$route.query.area;
      if (province !== undefined && province !== "") {
        this.ifShowPlatform = false;
        this.areatitle = "横峰县";
        that.isChildPage = true;

        params.append("province", province);
        params.append("city", city);
        params.append("area", area);
      } else {
        this.ifShowPlatform = true;
        this.areatitle = "上饶市";
        that.isChildPage = false;

        params = {};
      }

      return params;
    },

    // 设置 router 的 params 参数

    setQueryParams() {
      let that = this;
      let params = {};
      params.province = that.$route.query.province;
      params.city = that.$route.query.city;
      params.area = that.$route.query.area;

      return params;
    },

    // 跳转副中心:
    toHengFengPage() {
      let that = this;
      let params = that.setQueryParams();
      that.$router.push({ path: "/", query: params });
    },

    // 获取表格数据
    getTableDatas() {
      let that = this;
      let params = that.setParams();
      that.$ajax
        .post("homePage/queryTotalUploadList", params)
        .then(response => {
          console.log(response, "xx");
          that.tableDatas = response.totalUploadList;
		  that.tableTotal = response.sum;
        })
        .catch(error => {});
    },
    setTitleTxt() {
      let that = this;
      if (
        that.$route.query.province != "" &&
        that.$route.query.province != undefined
      ) {
        that.titleTxt = "横峰县";
      } else {
        that.titleTxt = "上饶市";
      }
    },
	// 跳转医院详情
	toHosDetail(hosId) {
	  console.log(hosId);
	  let that = this;
	  that.$router.push({ path: "/hosIndex", query: { organ_id: hosId } });
	}
  },
  created() {
    this.setTitleTxt();
    this.getTableDatas();
  },
  watch: {}
};
</script>


<style lang="stylus">
.platformTotal
  margin-top
  .institution-title
    margin-top 100px
    text-align center
    img
      height 75px
  .navigation
    font-size 16px
    width 1200px
    margin 50px auto 0px auto
    border-bottom 2px solid #E1E1E1
    padding-bottom 20px
    span
      cursor pointer
  .content
    width 1200px
    margin 0 auto
    padding-top 30px
    .content-title
      height 36px
      font-size 36px
      font-family Microsoft YaHei
      font-weight 400
      color rgba(27, 27, 27, 1)
      line-height 46px
      text-align center
      padding 40px 0 30px
    table
      width 100%
      border 1PX solid #EEEEEE
      font-size 16px
      color #333
      border-collapse collapse
      border-spacing 0
      margin-bottom 80px
      td
        line-height 60px
        text-align center
        border none
      tr
        border none
        padding 0
        margin 0
        background-color #fff
        &:first-child
          color #666666
          font-weight bold
        /* *匹配奇偶行： */
        &:nth-child(2n + 1 )
          background-color #fff
        &:nth-child(2n)
          background-color #fff
          background-color rgba(247, 246, 249, 1)
        &:not(:first-child)
          td
            padding 0
            margin 0
            &:first-child
              color #0080CB
              cursor pointer
        &:last-child
          td
            &:first-child
              color #333
            &:nth-last-child(2)
              color #333
</style>